/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/cognitive-complexity */
import { Space, Row, Col, Button, message as toaster } from 'antd';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { FieldArray, Formik } from 'formik';
import { groupBy, isArray, flattenDeep, flatten, isEmpty, cloneDeep } from 'lodash';
import { Form, Radio, DatePicker, Input as FormInput, Select } from 'formik-antd';
import PropTypes from 'prop-types';
import React, { useState, useEffect, Fragment, useRef, useMemo } from 'react';
import {
	initialValues,
	initialValuesAmortization,
	getTotalAmount,
	getBalanceAmount,
	getSplitedTotal,
	disableDateRanges,
	getAmortizationValidation,
	getAmount,
	SaveBtn,
	ClearBtn,
	ConfirmBtn,
	Label,
	BillType,
	addRemovePayment,
	NEFTRefCheck,
	UPIRefCheck,
	Bill,
	BillNo,
	AmountFilled,
	checkDisabled,
	getCashMaxAmount,
	UTRInfo,
	UTRInforBox,
	ImageBox,
	getIndividualAmount,
} from 'components/pages/collection/invoice-form-controller';
import { Text, Box, Flex, Image } from 'atoms';
import {
	ClearConfirmation,
	DuplicateReferenceConfirmation,
	AutoCompleteUpi,
	ConfirmBeforeUpdate,
	DynamicQRCode,
} from 'components/pages/collection';
import { Debug } from 'forms/Debug';
import {
	saveAllInvoicesComplete,
	clearAllInvoices,
	getInvoices,
	getReceivedInvoices,
	getAmortizeLogic,
} from 'store/invoiceSlice';
import { useQueryParams } from 'hooks';
import { theme } from 'styles/theme';
import { Rupee } from 'components';
import { getDateDiff, dateValidationCheck } from 'utils';
import { AR } from 'utils/constants';
import ManualMode from 'assets/ManualMode.svg';
import DynamicMode from 'assets/DynamicMode.svg';

const BoxWrap = styled(Flex)`
	justify-content: space-between;
`;
// const BoxToolTip = styled(Box)`
// 	margin-left: 70px;
// 	margin-top: 10px;
// `;
// const ErrorImage = styled(Image)`
// 	margin-left: 90px;
// `;

const Error = styled(Text)`
	color: red;
	fomt-size: 10px;
`;

const FormInputError = styled(FormInput)`
	fomt-size: 10px;
`;
const { TextArea } = FormInput;
const { Option } = Select;
const NBB = 'No Bill Back';

function getTotal(values = []) {
	return values?.reduce((acc, curr) => acc + Number(curr.amount) || 0, 0);
}

function getFlattenTotal(values = []) {
	const result = Object.keys(values).map((key) => {
		if (values[key]?.length === 1) {
			return values[key];
		}
		const total = getTotal(values[key]) || 0;

		return [{ ...values[key][0], amount: total }];
	});

	return result?.length > 0 ? flatten(result) : undefined;
}

function getSplitInitValue(storeInvoices, totalOutstanding, isEditMode = false) {
	return storeInvoices?.map((item) => ({
		id: item?.id,
		amount: isEditMode ? getTotal(item?.payment) : undefined,
		current_outstanding_amount: Number(item?.initial_outstanding_amount),
		oldStatus: item?.status,
		status: isEditMode ? item?.status : undefined,
		reason: isEditMode ? item?.reason : undefined,
		remarks: isEditMode ? item?.remarks?.trim() : undefined,
		invoice_date: item?.invoice_date,
		invoice_age: getDateDiff(item?.invoice_date),
		billtype: item?.billtype,
		invoice_no: item?.invoice_no,
		totalOutstanding,
		oldData: item,
	}));
}

const style = {
	width: '100%',
	borderRadius: 0,
};

export default function InvoiceFormAmortization({
	storeInvoices,
	totalOutstanding,
	isEditMode,
	previousUPIPayments = [],
	deliveryDate,
}) {
	const dispatch = useDispatch();
	const { banks = [], reasons = [] } = useSelector((state) => state.invoice);
	const { me = {}, selectedSalesMan = {} } = useSelector((state) => state.user);
	const [formInitialValues, setFormInitialValues] = useState({
		...initialValuesAmortization,
		current_outstanding_amount: Number(totalOutstanding),
		store_id: storeInvoices?.[0]?.store_id,
		store_name: storeInvoices?.[0]?.store_name,
		splitInvoices: getSplitInitValue(storeInvoices, totalOutstanding),
	});
	const { salesmanId = undefined } = useQueryParams();

	const [showClearConfirmation, setShowClearConfirmation] = useState(false);
	const [showDuplicateError, setShowDuplicateError] = useState(false);
	const [showUpdateConfirmation, setShowUpdateConfirmation] = useState(false);
	const [showDynamicQRCode, setShowDynamicQRCode] = useState(false);
	const [showUpiPopup, setShowUpiPopup] = useState(false);
	const [UPIRefFieldIndex, setUPIRefFieldIndex] = useState(0);
	// on create mode start the index from 0, on edit mode based on previous data change the initial value
	const [dynamicUPIData, setDynamicUPIData] = useState(null);
	const [manualModeEditData, setManualModeEditData] = useState({});
	const formRef = useRef();
	const history = useHistory();
	const [invalidData, setInvalidData] = useState({ upis: [], neft: [], message: [] });

	console.log('UPIRefFieldIndex on top', UPIRefFieldIndex);

	const verifiedBy = useMemo(() => {
		const cashier = storeInvoices?.every(
			(item) => item?.invoice_verification_status === 'VerifiedByCashier'
		);
		const segregator = storeInvoices?.some(
			(item) =>
				item?.invoice_verification_status === 'VerifiedBySegregator' ||
				item?.invoice_verification_status?.includes('Cashier')
		);
		const delegatedSalesmanName = storeInvoices?.some((item) => item?.delegated_salesman_name);

		return { cashier, segregator, delegatedSalesmanName };
	}, [storeInvoices]);
	const [checkNullPDC, SetcheckNullPDC] = useState(0);

	function checkNullPDCFUnc() {
		if (deliveryDate?.cheque_credit_period === null) {
			SetcheckNullPDC(false);
		} else {
			SetcheckNullPDC(true);
		}
	}
	useEffect(() => {
		/**
		 * To Prefill the data - On Edit mode
		 */
		if (isEditMode) {
			console.log('UPIRefFieldIndex on edit', UPIRefFieldIndex);
			/**
			 * On Edit Mode
			 */
			const newInit = {
				current_outstanding_amount: Number(totalOutstanding),
				store_id: storeInvoices?.[0]?.store_id,
				store_name: storeInvoices?.[0]?.store_name,
				update: 'true',
			};
			/**
			 * group the payment types by payment_type key
			 */
			const splited = getSplitInitValue(storeInvoices, totalOutstanding, isEditMode);
			const onlyPayment = flattenDeep(splited?.map((item) => item?.oldData?.payment));
			const groupedPayments = groupBy(onlyPayment, 'payment_type');
			let upiData = groupBy(groupedPayments?.UPI, 'reference_number');
			let chequeData = groupBy(
				groupedPayments?.Cheque,
				(item) => `${item.reference_number}-${item.due_date}-${item.bank_id}`
			);
			let neftData = groupBy(groupedPayments?.NEFT, 'reference_number');

			upiData = getFlattenTotal(upiData) || [];
			chequeData = getFlattenTotal(chequeData);
			neftData = getFlattenTotal(neftData);

			/**
			 * other than old data we are adding, upi list data also if its not there in edit mode
			 */
			const onlyRefNo = upiData?.map((item) => item?.reference_number);
			let newonlyRefNofromApi = previousUPIPayments?.map((item) => item?.utr);

			newonlyRefNofromApi = newonlyRefNofromApi?.filter((item) => !onlyRefNo?.includes(item));
			newonlyRefNofromApi = previousUPIPayments?.filter((item) =>
				newonlyRefNofromApi?.includes(item?.utr)
			);
			newonlyRefNofromApi = newonlyRefNofromApi?.map((item) => ({
				id: Math.random(),
				reference_number: item?.utr,
				bank_statement_id: undefined,
				amount: item?.amount,
				type: 'qrcode',
			}));
			upiData = [...upiData, ...newonlyRefNofromApi];

			console.log('newonlyRefNofromApi', newonlyRefNofromApi);
			console.log('upiData', upiData);

			newInit.cash = getTotal(groupedPayments?.Cash) || '';
			newInit.upiData = upiData || initialValues?.upiData;
			newInit.chequeData = chequeData || initialValues?.chequeData;
			newInit.neftData = neftData || initialValues?.neftData;
			newInit.splitInvoices = splited;
			newInit.fillType = 'Manual';
			newInit.cashMaxLimit = getCashMaxAmount(storeInvoices); // to find max amount collected in cash
			setFormInitialValues({ ...newInit });
			if (upiData?.length > 0 && UPIRefFieldIndex === 0) {
				setUPIRefFieldIndex(upiData.length);
			}
		} else {
			/**
			 * On Create Mode
			 */
			setFormInitialValues({
				...initialValues,
				...(previousUPIPayments?.length > 0 && {
					upiData: previousUPIPayments?.map((item) => ({
						id: Math.random(),
						reference_number: item?.utr,
						bank_statement_id: undefined,
						amount: item?.amount,
						type: 'qrcode',
					})),
				}),
				current_outstanding_amount: Number(totalOutstanding),
				store_id: storeInvoices?.[0]?.store_id,
				store_name: storeInvoices?.[0]?.store_name,
				splitInvoices: getSplitInitValue(storeInvoices, totalOutstanding),
				cashMaxLimit: getCashMaxAmount(storeInvoices), // to find max amount collected in cash
			});

			/**
			 * On first time form load, check if any already added QR code available
			 */
			console.log('previousUPIPayments', previousUPIPayments);
			console.log('UPIRefFieldIndex', UPIRefFieldIndex);

			if (previousUPIPayments?.length > 0 && UPIRefFieldIndex === 0) {
				console.log('came inside');
				setUPIRefFieldIndex(UPIRefFieldIndex + previousUPIPayments.length);
			}
		}

		checkNullPDCFUnc();

		return () => {
			setFormInitialValues({ ...initialValues });
		};
	}, [storeInvoices, totalOutstanding, isEditMode]);

	function addErrorData(upis, nefts, message, formToucher, data) {
		setInvalidData({ upis, neft: nefts, message });

		for (let i = 0; i < data.upiData.length; i += 1) {
			if (upis.find((v) => v === data.upiData[i].reference_number)) {
				formToucher(`upiData[${i}].reference_number`);
			}
		}

		for (let i = 0; i < data.neftData.length; i += 1) {
			if (nefts.find((v) => v === data.neftData[i].reference_number)) {
				formToucher(`neftData[${i}].reference_number`);
			}
		}
	}

	function handleRedirect() {
		if (me.type === AR) {
			history.push(`/collection?salesmanId=${selectedSalesMan?.id}`);
		} else {
			history.push('/collection');
		}
	}

	function clearBottomInvoices() {
		if (formRef?.current) {
			formRef.current.setFieldValue(`fillType`, undefined);
			formRef.current.values?.splitInvoices?.forEach((_, i) => {
				formRef.current.setFieldValue(`splitInvoices[${i}].amount`, undefined);
				formRef.current.setFieldValue(`splitInvoices[${i}].status`, undefined);
				formRef.current.setFieldValue(`splitInvoices[${i}].remarks`, undefined);
				formRef.current.setFieldValue(`splitInvoices[${i}].reason`, undefined);
			});
		}
	}

	const DateFormat = 'YYYY-MM-DD HH:mm:ss';
	const start_time = '19:04:10';

	function getLocalDate(date) {
		console.log(date);
		const localDate = moment(date).format(DateFormat);
		const contactDate = moment(`${localDate}${start_time}`).format(DateFormat);

		console.log(contactDate);

		console.log(localDate);

		return localDate;
	}

	// 	const DateFormat = 'DD-MM-YYYY';
	// const TIME_FORMAT = 'hh:mm a';

	// function getLocalDate(date) {
	// 	// console.log(moment(date).add(330, 'minutes').format(DateFormat));
	// 	// console.log(moment.utc(date, 'MM/DD/YYYY HH:mm').toDate());

	// 	if (date) {
	// 		return moment(date).add(330, 'minutes').format(DateFormat);
	// 	}
	// 	return '';
	// }

	// function getLocalTime(time) {
	// 	if (time) {
	// 		return moment(time).add(330, 'minutes').format(TIME_FORMAT);
	// 	}
	// 	return '';
	// }

	function getPaymentsData(values) {
		return {
			cash:
				values?.cash > 0
					? {
							payment_type: 'Cash',
							amount: values?.cash,
					  }
					: [],
			cheque: values?.chequeData
				?.filter((item) => item?.amount && item?.reference_number)
				?.map((item) => ({
					payment_type: 'Cheque',
					reference_number: item?.reference_number,
					due_date: getLocalDate(item?.due_date),
					amount: item?.amount,
					bank_id: item?.bank_id,
				})),
			neft: values?.neftData
				?.filter((item) => item?.amount && item?.reference_number)
				?.map((item) => ({
					payment_type: 'Neft',
					reference_number: item?.reference_number,
					amount: item?.amount,
				})),
			upi: values?.upiData
				?.filter((item) => item?.amount && item?.reference_number)
				.map((item) => ({
					payment_type: 'Upi',
					reference_number: item?.reference_number,
					amount: item?.amount,
					type: item?.type,
				})),
		};
	}

	function toCheckManualSplit(values, setSubmitting) {
		const collected = cloneDeep(values);

		console.log('toCheckManualSplit');
		let isNoError = true;

		if (values?.fillType === 'Manual') {
			const total = getTotalAmount(values);
			const upi = getIndividualAmount(values?.upiData);
			const cheque = getIndividualAmount(values?.chequeData);
			const neft = getIndividualAmount(values?.neftData);
			let currentCash = values?.cash;
			let otherThanCash = upi + cheque + neft || 0;
			let added = 0;

			console.log('currentCash 1 ?? ', currentCash);
			console.log('fillType ?? ', values?.fillType);
			console.log('splitInvoices ?? ', collected?.splitInvoices);
			console.log('all total 1 ?? ', total);

			collected?.splitInvoices?.every((split) => {
				let error = '';
				const cash_limit_allowed = Number(split?.oldData?.cash_limit_allowed) || 0;

				console.log('-------------------', split?.id);
				console.log('split?.amount ?? ', split?.amount);
				console.log('split?.cash_limit_allowed ?? ', cash_limit_allowed);
				console.log('currentCash   2s ?? ', currentCash);
				console.log('otherThanCash ?? ', otherThanCash);

				if (split?.amount > 0) {
					error = `Error!, Invoice #${split?.invoice_no} allowed to collect only ${cash_limit_allowed} as cash`;

					if (cash_limit_allowed === 0) {
						console.log('wix bottle 0');

						if (otherThanCash < split?.amount) {
							console.log('wix bottle 1');

							isNoError = false;
						}
						otherThanCash -= split.amount;
						added += split.amount;
						console.log('added 1', added);
					} else if (cash_limit_allowed > 0) {
						console.log('currentCash 1', currentCash);
						console.log('otherThanCash 1', otherThanCash);
						console.log('wix bottle 3');
						if (cash_limit_allowed <= currentCash) {
							console.log('wix bottle 4');

							if (split?.amount <= cash_limit_allowed) {
								currentCash -= split.amount;
								added += split.amount;
								console.log('wix bottle 41');
							} else if (split?.amount >= cash_limit_allowed) {
								currentCash -= cash_limit_allowed;
								added += cash_limit_allowed;
								console.log('wix bottle 42');
							} else {
								console.log('wix bottle 43');
							}

							console.log('added 2', added);
							console.log('currentCash ~~', currentCash);
							if (otherThanCash === 0 && currentCash > 0 && added === total) {
								console.log('wix crashed 41');
								isNoError = false;
							}
						} else if (cash_limit_allowed > currentCash) {
							console.log('wix bottle 5');

							if (split?.amount >= currentCash) {
								currentCash = 0;
								added += currentCash;
								console.log('wix bottle 51');
							} else if (split?.amount < currentCash) {
								console.log('wix bottle 52');
								currentCash -= split.amount;
								added += split.amount;
							}

							const balance = otherThanCash - currentCash;

							console.log('balance ssss', balance);
							console.log('added ssss', added);
							console.log('currentCash ssss', currentCash);
							console.log('otherThanCash ssss', otherThanCash);

							if (balance > 0) {
								// currentCash = 0;
								otherThanCash -= balance;
								added += split.amount;
								console.log('added 3', added);
							}
						}
					}

					console.log('currentCash 2', currentCash);
					console.log('otherThanCash 2', otherThanCash);
				}

				console.log('isNoError', isNoError);
				console.log('ee', error);

				if (!isNoError) {
					toaster.error(error);
					setSubmitting(false);

					return false;
				}

				console.log('currentCashs', currentCash);
				console.log('otherThanCash final', otherThanCash);
				console.log('payment iss okss');
				console.log('######');

				return true;
			});

			if (currentCash > 0 && isNoError) {
				isNoError = false;
				toaster.error(`${currentCash} Cash amount added extra`);
				setSubmitting(false);
			}

			console.log('manual endss');
		}

		return isNoError;
	}

	function handleSubmit(values, { setErrors, setSubmitting, setFieldTouched }) {
		if (!toCheckManualSplit(values, setSubmitting)) {
			return false;
		}

		console.log('values', values);

		const payments = getPaymentsData(values);

		const data = {
			invoices: values.splitInvoices?.map((item) => ({
				id: item?.id,
				invoice_status_marked_by_salesman: item?.status,
				remarks_from_salesman: item?.remarks ?? '',
				reason_from_salesman: item?.reason ?? null,
				...(values?.fillType === 'Manual' && {
					salesman_filled_amount: item?.amount ?? null,
				}),
				cash_limit_allowed: item?.oldData?.cash_limit_allowed,
				store_cash_limit_allowed: item?.oldData?.store_cash_limit_allowed,
			})),
			payments,
		};

		if (values?.update) {
			data.update = values?.update;
		}

		if (values?.fillType === 'Manual') {
			data.manual = 'true';
		}

		console.log('payments', payments);
		console.log('data', data);

		return dispatch(saveAllInvoicesComplete(data, setErrors))
			.then(() => {
				dispatch(getInvoices(salesmanId));
				dispatch(getReceivedInvoices(salesmanId));
				handleRedirect();
			})
			.catch((er) => {
				console.log('failed with 400', er);
				// toaster.error(`Error on Invoices save`);
				const rd = er?.response?.data;

				if (rd && er?.response.status === 400) {
					if (rd.mode === 'NEFT') {
						addErrorData([], rd.reference_numbers, rd.message, setFieldTouched, values);
					} else if (rd.mode === 'UPI') {
						addErrorData(rd.reference_numbers, [], rd.message, setFieldTouched, values);
					}
				}
			})
			.finally(() => {
				setSubmitting(false);
			});
	}

	const handleCancel = () => {
		setShowDuplicateError(false);
	};

	const handleOk = () => {
		if (formRef?.current) {
			setShowDuplicateError(false);
			formRef.current.handleSubmit();
		}
	};

	const handleUpdateCancel = () => {
		setShowUpdateConfirmation(false);
	};

	/**
	 * New way handling the clear all, with single api
	 */
	function handleUpdateOk() {
		if (formRef?.current) {
			console.log('handleClearAllAndUpdate', formRef?.current?.values?.splitInvoices);
			const clearAllData = formRef?.current?.values?.splitInvoices?.map((item) => ({
				invoice_id: item?.id,
				invoice_no: item?.invoice_no,
				status: item?.status,
			}));

			console.log('clearAllData ', clearAllData);

			dispatch(clearAllInvoices(clearAllData)).then((res) => {
				console.log('ress', res);
				setShowUpdateConfirmation(false);
				formRef.current.handleSubmit();
			});
		}
	}

	function triggerBEAmortizeLogic(values) {
		const data = {
			invoices: values?.splitInvoices?.map((item) => ({
				id: item?.id,
				cash_limit_allowed: item?.oldData?.cash_limit_allowed,
				store_cash_limit_allowed: item?.oldData?.store_cash_limit_allowed,
			})),
			payments: getPaymentsData(values),
		};

		return dispatch(getAmortizeLogic(data)).then((res) => res?.data);
	}

	async function handleFillTypeChange(e, values, setFieldValue) {
		const total = getTotalAmount(values);

		if (total === 0) {
			/**
			 * without entering any amount if they click Manual/Auto,
			 * it will change all invoice status and Bill Back automatically
			 */
			values?.splitInvoices?.forEach((_, i) => {
				setFieldValue(`splitInvoices[${i}].status`, 'Bill Back');
				setFieldValue(`splitInvoices[${i}].amount`, undefined);
			});
		} else {
			/**
			 * Radio Manual, Auto change function
			 */
			values?.splitInvoices?.forEach((_, i) => {
				setFieldValue(`splitInvoices[${i}].amount`, undefined);
				setFieldValue(`splitInvoices[${i}].status`, undefined);
			});

			if (e?.target?.value === 'Auto') {
				/**
				 * If total is valid then only will fill the amount automatically
				 */
				if (total > 0 && values?.splitInvoices?.length > 0) {
					const amortizeData = await triggerBEAmortizeLogic(values);

					values?.splitInvoices?.forEach((item, i) => {
						// Below code is newly added backend Amortize Logic
						const result = amortizeData.find((amor) => amor?.invoice_id === item?.id);

						setFieldValue(`splitInvoices[${i}].status`, result?.suggested_status);
						setFieldValue(
							`splitInvoices[${i}].amount`,
							getTotal(result?.invoice_payments)
						);

						// Below code is manual spliting logic
						// /**
						//  * Based on inovice age date, fill the amount to each invoice automatically
						//  */
						// const outstanding = item.current_outstanding_amount;
						// let amount = 0;

						// if (total >= outstanding) {
						// 	/**
						// 	 * outstanding within the total range
						// 	 */
						// 	amount = outstanding;
						// 	total -= outstanding;
						// } else if (total <= outstanding && total !== 0) {
						// 	/**
						// 	 * outstanding exceeded the total amount
						// 	 */
						// 	amount = total;
						// 	total = 0;
						// }
						// setFieldValue(`splitInvoices[${i}].amount`, amount);
						// if (amount === outstanding) {
						// 	/**
						// 	 * if the filled amount is equal to outstanding amount then make it as auto Bill Back
						// 	 */
						// 	setFieldValue(`splitInvoices[${i}].status`, NBB);
						// }
					});
				} else if (e?.target?.value === 'Manual') {
					setFieldValue(`fillType`, 'Manual');
				} else {
					setFieldValue(`fillType`, undefined);
				}
			}
		}
	}

	function handleManualEditMode(data, index) {
		if (data?.type === 'Manual') {
			setManualModeEditData({
				data,
				isManualEditMode: true,
				index,
			});
			setShowDynamicQRCode(true);
		}
	}

	function handleUPIQRCodeClose() {
		setShowDynamicQRCode(false);
		setDynamicUPIData(null);
	}

	function handleDeleteManualUPI() {
		setUPIRefFieldIndex(UPIRefFieldIndex - 1);
		setManualModeEditData({});
		handleUPIQRCodeClose();
	}

	function handleQRCodeSubmit(saveData = null) {
		console.log('saveData 1x', saveData);

		if (saveData?.reference_number) {
			if (saveData?.manualModeEditData?.data?.id) {
				/**
				 * Upi data edit secttion
				 */
				const updateIndex = saveData?.manualModeEditData?.index;

				formRef?.current?.setFieldValue(
					`upiData[${updateIndex}].reference_number`,
					saveData?.reference_number
				);
				formRef?.current?.setFieldValue(
					`upiData[${updateIndex}].bank_statement_id`,
					saveData?.bank_statement_id
				);
				formRef?.current?.setFieldValue(
					`upiData[${updateIndex}].amount`,
					saveData?.upiAmount
				);

				// formRef?.current
				// 	?.validateForm()
				// 	.then(() => console.log('Revalidation Complete - AS'));

				setTimeout(() =>
					formRef.current?.setFieldTouched(
						`upiData[${updateIndex}].reference_number`,
						true
					)
				);
			} else {
				console.log('UPIRefFieldIndex', UPIRefFieldIndex);
				/**
				 * On new upi data adding section
				 */
				formRef?.current?.setFieldValue(`upiData[${UPIRefFieldIndex}].id`, Math.random());
				formRef?.current?.setFieldValue(
					`upiData[${UPIRefFieldIndex}].reference_number`,
					saveData?.reference_number
				);
				formRef?.current?.setFieldValue(
					`upiData[${UPIRefFieldIndex}].bank_statement_id`,
					saveData?.bank_statement_id
				);
				formRef?.current?.setFieldValue(
					`upiData[${UPIRefFieldIndex}].amount`,
					saveData?.upiAmount
				);
				formRef?.current?.setFieldValue(
					`upiData[${UPIRefFieldIndex}].type`,
					saveData?.type
				);
				setUPIRefFieldIndex(UPIRefFieldIndex + 1);
			}
			setDynamicUPIData(null);
		}
		handleUPIQRCodeClose();
	}

	console.log(deliveryDate);

	console.log(checkNullPDC);

	return (
		<>
			{/* <button type="button" onClick={() => addErrorData(['12345678'], ['123456789'])}>
				Add errors
			</button> */}
			<Formik
				enableReinitialize
				initialValues={formInitialValues}
				validationSchema={getAmortizationValidation(
					formInitialValues,
					isEditMode,
					invalidData
				)}
				onSubmit={handleSubmit}
				initialTouched={{
					upiData: true,
					chequeData: true,
					neftData: true,
					splitInvoices: formInitialValues.splitInvoices.map(() => ({
						reason: true,
						remarks: true,
						status: true,
					})),
					fillType: true,
				}}
				innerRef={formRef}
			>
				{({ values, errors, setFieldValue, isValid, dirty }) => (
					<Form
						layout="vertical"
						hideRequiredMark
						className={
							verifiedBy?.cashier ?? verifiedBy?.delegatedSalesmanName
								? 'invoice-formik-form disabled-div'
								: 'invoice-formik-form'
						}
						style={{
							padding: '0 1rem 2rem',
						}}
					>
						<Text textAlign="center" fontSize="10px">
							Cash limit for this store:{' '}
							<Text fontWeight="bold" as="span">
								<Rupee>{values?.cashMaxLimit}</Rupee>
							</Text>
						</Text>
						<Row
							justify="end"
							align="middle"
							className={values.fillType ? 'disabled-div--' : ''}
						>
							<Col span={20} className="invoice-form">
								<Row
									justify="space-around"
									align="middle"
									className="invoice-form-first-row"
								>
									<Col span={8}>
										<BillType
											isValidAmount={getAmount(values.cash)}
											className="btlr-4"
										>
											Cash
										</BillType>
									</Col>
									<Col span={16} className="cash-error-in-form">
										<Form.Item
											name="cash"
											hasFeedback={false}
											showValidateSuccess={false}
										>
											<FormInput
												type="number"
												min={0}
												max={199999}
												prefix="₹"
												name="cash"
											/>
										</Form.Item>
									</Col>
								</Row>
								<Row justify="space-around" align="middle">
									<Col span={8}>
										<BillType>UPI</BillType>
									</Col>
									<Col span={16} className="center p-10">
										<Button
											onClick={() => {
												setShowDynamicQRCode(true);
												setDynamicUPIData(null);
												setManualModeEditData(null);
											}}
											className="center w-75"
											type="primary"
										>
											Scan QR
										</Button>

										{/* <p>{JSON.stringify(errors)}</p>
										{invalidData.upis.find(
											(v) => v === values?.upiData?.[0]?.reference_number
										) && (
											<Tooltip title="NEFT reference number entered as UPI">
												<ErrorImage src={Error} />
											</Tooltip>
										)} */}
									</Col>
								</Row>
								{values?.upiData?.[0]?.amount &&
									values?.upiData?.map((rowData, index) => (
										<UTRInforBox
											key={rowData?.id}
											onClick={() => handleManualEditMode(rowData, index)}
										>
											<UTRInfo>
												<Flex alignItems="center" justifyContent="center">
													<ImageBox>
														<Image
															src={
																rowData?.type === 'qrcode'
																	? DynamicMode
																	: ManualMode
															}
															alt="ManualMode"
															height={17}
															width={18}
														/>
													</ImageBox>
													<Flex flexDirection="column" pl="0.5rem">
														<Text fontSize="8px" color="#656565">
															UTR Reference Number:
														</Text>
														<Text fontSize="10px" color="#272727">
															{rowData?.reference_number}
														</Text>
													</Flex>
												</Flex>
												<Text fontSize="13px">
													<Rupee>{rowData?.amount}</Rupee>
												</Text>
											</UTRInfo>
											{errors?.upiData &&
												errors?.upiData[index]?.reference_number && (
													<Error>
														{errors?.upiData[index]?.reference_number}
													</Error>
												)}
										</UTRInforBox>
									))}
								<FieldArray
									name="chequeData"
									render={(arrayHelpers) => (
										<div>
											{values?.chequeData?.map((rowData, index) => (
												<Fragment key={rowData?.id}>
													<Row justify="space-around" align="middle">
														<Col span={8} className="add-section">
															<BillType
																isValidAmount={getAmount(
																	values.chequeData[index]?.amount
																)}
															>
																Cheque
															</BillType>
															{checkNullPDC && (
																<Button
																	onClick={() =>
																		addRemovePayment(
																			arrayHelpers,
																			index,
																			'cheque'
																		)
																	}
																	className="add-btn"
																	type="button"
																>
																	{index === 0 ? '+' : '-'}
																</Button>
															)}
														</Col>
														<Col span={16}>
															{checkNullPDC && (
																<Form.Item
																	name={`chequeData[${index}].amount`}
																	hasFeedback={false}
																	showValidateSuccess={false}
																>
																	<FormInput
																		type="number"
																		min={0}
																		prefix="₹"
																		name={`chequeData[${index}].amount`}
																		onChange={(e) => {
																			if (
																				e.target.value ===
																					'0' ||
																				e.target.value ===
																					''
																			) {
																				setFieldValue(
																					`chequeData[${index}].reference_number`,
																					undefined
																				);
																				setFieldValue(
																					`chequeData[${index}].bank_id`,
																					undefined
																				);
																				setFieldValue(
																					`chequeData[${index}].due_date`,
																					undefined
																				);
																			}
																		}}
																	/>
																</Form.Item>
															)}
															{!checkNullPDC &&
																deliveryDate?.cheque_credit_period ==
																	null && (
																	<Form.Item
																		name={`chequeData[${index}].amount`}
																		hasFeedback={false}
																		showValidateSuccess={false}
																		className="show-pdc-error"
																	>
																		<FormInputError
																			type="string"
																			min={0}
																			prefix="₹"
																			name={`chequeData[${index}].amount`}
																			value="Error: Contact Support Team"
																			disabled
																		/>
																	</Form.Item>
																)}
														</Col>
													</Row>
													{getAmount(
														values.chequeData[index]?.amount
													) && (
														<Row>
															<Col
																span={24}
																className="p-10 no-border"
															>
																<div className="invoice-form-controls">
																	<Row
																		justify="space-between"
																		align="middle"
																	>
																		<Col span={11}>
																			<div className="invoice-form-remarks">
																				<Form.Item
																					name={`chequeData[${index}].reference_number`}
																					hasFeedback={
																						false
																					}
																					showValidateSuccess={
																						false
																					}
																					label="*Cheque no:"
																					className="custom-label"
																					labelCol={{
																						span: 24,
																					}}
																					wrapperCol={{
																						span: 24,
																					}}
																				>
																					<FormInput
																						name={`chequeData[${index}].reference_number`}
																						placeholder="last 6 digits"
																						pattern="[0-9]*"
																						inputMode="numeric"
																						maxLength={
																							6
																						}
																					/>
																				</Form.Item>
																			</div>
																		</Col>
																		<Col
																			span={12}
																			className="invoice-form-remarks"
																		>
																			<Form.Item
																				name={`chequeData[${index}].bank_id`}
																				hasFeedback={false}
																				showValidateSuccess={
																					false
																				}
																				label="*Bank Name"
																				className="custom-label"
																				labelCol={{
																					span: 24,
																				}}
																				wrapperCol={{
																					span: 24,
																				}}
																			>
																				<Select
																					getPopupContainer={(
																						trigger
																					) =>
																						trigger.parentNode
																					}
																					name={`chequeData[${index}].bank_id`}
																					showSearch
																					optionFilterProp="children"
																					className="w-100"
																					placeholder="*Bank Name"
																					allowClear
																					filterOption={(
																						input,
																						option
																					) =>
																						option.children
																							.toLowerCase()
																							.indexOf(
																								input.toLowerCase()
																							) >= 0
																					}
																				>
																					{banks?.map(
																						(bank) => (
																							<Option
																								key={
																									bank.id
																								}
																								value={
																									bank?.id
																								}
																							>
																								{
																									bank?.name
																								}
																							</Option>
																						)
																					)}
																				</Select>
																			</Form.Item>
																		</Col>
																	</Row>
																	<Row
																		justify="space-between"
																		align="middle"
																	>
																		<Col span={11}></Col>
																		<Col span={12}>
																			<Form.Item
																				name={`chequeData[${index}].due_date`}
																				hasFeedback={false}
																				showValidateSuccess={
																					false
																				}
																				label="*Due Date"
																				className="custom-label"
																				labelCol={{
																					span: 24,
																				}}
																				wrapperCol={{
																					span: 24,
																				}}
																			>
																				<DatePicker
																					getPopupContainer={(
																						trigger
																					) =>
																						trigger.parentNode
																					}
																					name={`chequeData[${index}].due_date`}
																					className="w-100"
																					format="DD-MM-YYYY"
																					allowClear
																					picker="date"
																					disabledDate={disableDateRanges(
																						values,
																						deliveryDate
																					)}
																				/>
																			</Form.Item>
																		</Col>
																	</Row>
																</div>
															</Col>
														</Row>
													)}
												</Fragment>
											))}
										</div>
									)}
								/>
								<FieldArray
									name="neftData"
									render={(arrayHelpers) => (
										<div>
											{values?.neftData?.map((rowData, index) => (
												<Fragment key={rowData?.id}>
													<Row
														justify="space-around"
														align="middle"
														className={
															values.neftData.length - 1 === index
																? 'invoice-form-last-row'
																: 'invoice-form'
														}
													>
														<Col span={8} className="add-section">
															<BillType
																isValidAmount={getAmount(
																	values.neftData[index]?.amount
																)}
															>
																NEFT
															</BillType>
															<Button
																onClick={() =>
																	addRemovePayment(
																		arrayHelpers,
																		index,
																		'neft'
																	)
																}
																className="add-btn"
																type="button"
															>
																{index === 0 ? '+' : '-'}
															</Button>
														</Col>
														<Col span={16}>
															<Form.Item
																name={`neftData[${index}].amount`}
																hasFeedback={false}
																showValidateSuccess={false}
															>
																<FormInput
																	type="number"
																	min={0}
																	prefix="₹"
																	name={`neftData[${index}].amount`}
																	onChange={(e) => {
																		if (
																			e.target.value ===
																				'0' ||
																			e.target.value === ''
																		) {
																			setFieldValue(
																				`neftData[${index}].reference_number`,
																				undefined
																			);
																		}
																	}}
																/>
															</Form.Item>
														</Col>
													</Row>
													{getAmount(values.neftData[index]?.amount) && (
														<Row
															justify="space-around"
															align="middle"
															className={
																values.neftData.length - 1 === index
																	? 'invoice-form-last-row'
																	: 'invoice-form'
															}
														>
															<Col
																span={24}
																className="pt-10 px-10 no-border"
															>
																<Box
																	width="100%"
																	className="invoice-form-remarks"
																>
																	<Form.Item
																		name={`neftData[${index}].reference_number`}
																		hasFeedback={false}
																		showValidateSuccess={false}
																		label="* Ref no:"
																		className="custom-label"
																		labelCol={{ span: 24 }}
																		wrapperCol={{ span: 24 }}
																	>
																		<BoxWrap>
																			<FormInput
																				name={`neftData[${index}].reference_number`}
																				placeholder="Enter Ref.no"
																				minLength={6}
																				maxLength={22}
																			/>

																			{/* {invalidData.neft.find(
																				(v) =>
																					v ===
																					values.neftData[
																						index
																					]
																						.reference_number
																			) && (
																				<BoxToolTip>
																					<Tooltip
																						title="UPI reference number entered as NEFT"
																						marginLeft={
																							9
																						}
																					>
																						<Image
																							src={
																								Error
																							}
																						/>
																					</Tooltip>
																				</BoxToolTip>
																			)} */}
																		</BoxWrap>
																	</Form.Item>
																</Box>
															</Col>
														</Row>
													)}
												</Fragment>
											))}
										</div>
									)}
								/>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<Text fontSize="12px" fontWeight="300" py="10px" textAlign="left">
									Total: <span>₹{getTotalAmount(values)}</span>
								</Text>
							</Col>
						</Row>
						<Row align="middle">
							<Col span={12}>
								<AmountFilled isValid={getBalanceAmount(values) >= 0}>
									<span className="label">Amount to be filled</span>
									<span className="value">₹{getBalanceAmount(values)}</span>
								</AmountFilled>
							</Col>
							<Col span={12} className="invoice-form-controls right">
								<Form.Item
									name="fillType"
									hasFeedback={false}
									showValidateSuccess={false}
									className={verifiedBy?.segregator ? 'disabled-div' : ''}
								>
									<Radio.Group
										name="fillType"
										size="large"
										onChange={(e) =>
											handleFillTypeChange(e, values, setFieldValue)
										}
									>
										<Space
											direction="horizontal"
											className="custom-radio custom-big-radio"
										>
											<Radio value="Manual">
												<Label noMinWidth>Manual</Label>
											</Radio>
											<Radio value="Auto">
												<Label noMinWidth>Auto</Label>
											</Radio>
										</Space>
									</Radio.Group>
								</Form.Item>
							</Col>
						</Row>

						{/* Show error if collected amount and splited amount is not match */}
						{getBalanceAmount(values) !== 0 && getSplitedTotal(values) > 0 && (
							<Flex justifyContent="center" alignItems="center" mt="1rem">
								<Text as="p" color="#ff4d4f" fontSize="12px" textAlign="center">
									Splited amount is not match with collected amount
								</Text>
							</Flex>
						)}

						<FieldArray
							name="splitInvoices"
							render={() => (
								<div className={!values?.fillType ? 'disabled-div mt-15' : 'mt-15'}>
									{values?.splitInvoices?.map((store, index) => (
										<Bill
											key={store?.id}
											flexDirection="column"
											isLast={index === values.splitInvoices.length - 1}
										>
											<Flex justifyContent="space-between">
												<Flex flexDirection="column">
													<BillNo>{store?.invoice_no}</BillNo>
													<Flex color={theme.colors.Onyx}>
														<Text fontSize="10px" pr="1rem">
															{dateValidationCheck(
																store?.invoice_date
															)
																? moment(
																		store?.invoice_date
																  ).format('DD-MM-YY')
																: 'NA'}
														</Text>
														<Text fontSize="10px">
															{dateValidationCheck(
																store?.invoice_date
															)
																? getDateDiff(store?.invoice_date)
																: 'NA'}{' '}
															days
														</Text>
													</Flex>
													<Box fontSize="10px">
														<Text>
															Allowed Cash Limit{' : '}
															<Rupee>
																{Number(
																	values?.splitInvoices[index]
																		?.oldData
																		?.cash_limit_allowed
																)?.toFixed(2)}
															</Rupee>
														</Text>
														{/* <Text>
															Ref ID{' : '}
															{Number(
																values?.splitInvoices[index]?.id
															)}
														</Text> */}
													</Box>
												</Flex>
												<Form.Item
													name={`splitInvoices[${index}].status`}
													hasFeedback={false}
													showValidateSuccess={false}
													className="status-error-in-form"
												>
													<Radio.Group
														name={`splitInvoices[${index}].status`}
														size="large"
														// disabled={verifiedBy?.segregator}
														disabled={checkDisabled(
															values.splitInvoices[index].oldData
																.invoice_verification_status
														)}
														onChange={(e) => {
															setFieldValue(
																`splitInvoices[${index}].status`,
																e.target.value
															);
															setFieldValue(
																`splitInvoices[${index}].reason`,
																undefined
															);
														}}
													>
														<Space
															direction="horizontal"
															className="custom-radio"
														>
															<Radio value={NBB}>
																<Label noMinWidth>
																	<Text maxWidth="40px">
																		{values.splitInvoices[index]
																			.billtype === 'Bill'
																			? 'Invoice Settled'
																			: 'Voucher Settled'}
																	</Text>
																</Label>
															</Radio>
															<Radio value="Bill Back">
																<Label noMinWidth>
																	<Text maxWidth="40px">
																		{values.splitInvoices[index]
																			.billtype === 'Bill'
																			? 'Invoice Returned'
																			: 'Voucher Returned'}
																	</Text>
																</Label>
															</Radio>
														</Space>
													</Radio.Group>
												</Form.Item>
											</Flex>
											<Flex
												justifyContent="space-between"
												alignItems="center"
											>
												<Flex flexDirection="column" mr="1rem">
													<Box
														fontSize="14px"
														color={theme.colors.EerieBlack}
													>
														<Rupee>
															{store?.current_outstanding_amount}
														</Rupee>
													</Box>
													<Text fontSize="10px">{store?.oldStatus}</Text>
												</Flex>
												<Box maxWidth="60%" my="1rem">
													<Form.Item
														name={`splitInvoices[${index}].amount`}
														hasFeedback={false}
														showValidateSuccess={false}
													>
														<FormInput
															type="number"
															min={0}
															prefix="₹"
															placeholder="Enter amount here"
															name={`splitInvoices[${index}].amount`}
															disabled={values?.fillType === 'Auto'}
														/>
													</Form.Item>
												</Box>
											</Flex>
											{(values.splitInvoices[index].amount <
												store?.current_outstanding_amount ||
												!values.splitInvoices[index].amount) &&
												values.splitInvoices[index].status ===
													'No Bill Back' && (
													<Box>
														<Form.Item
															name={`splitInvoices[${index}].reason`}
															hasFeedback={false}
															showValidateSuccess={false}
															label="*Reason"
															className="custom-label"
															labelCol={{
																span: 24,
															}}
															wrapperCol={{
																span: 24,
															}}
														>
															<Select
																getPopupContainer={(trigger) =>
																	trigger.parentNode
																}
																name={`splitInvoices[${index}].reason`}
																showSearch
																optionFilterProp="children"
																placeholder="*Reason"
																allowClear
																filterOption={(input, option) =>
																	option.children
																		.toLowerCase()
																		.indexOf(
																			input.toLowerCase()
																		) >= 0
																}
																className="reason-dropdown"
															>
																{reasons?.map((item) => (
																	<Option
																		key={item.id}
																		value={item?.id}
																	>
																		{item?.reason}
																	</Option>
																))}
															</Select>
														</Form.Item>
													</Box>
												)}
											<Box className="invoice-form-remarks">
												<Form.Item
													name={`splitInvoices[${index}].remarks`}
													label="Remarks"
													hasFeedback={false}
													showValidateSuccess={false}
													className="custom-label"
													labelCol={{ span: 24 }}
													wrapperCol={{ span: 24 }}
												>
													<TextArea
														className="full-remarks"
														name={`splitInvoices[${index}].remarks`}
														placeholder="Remarks"
														style={{
															height: 40,
															width: '100%',
														}}
													/>
												</Form.Item>
											</Box>
										</Bill>
									))}
								</div>
							)}
						/>

						{!isArray(errors?.chequeData) && (
							<Flex justifyContent="center" alignItems="center">
								<Text
									as="p"
									color="#ff4d4f"
									fontSize="12px"
									maxWidth="250px"
									textAlign="center"
								>
									{errors?.chequeData}
								</Text>
							</Flex>
						)}

						{NEFTRefCheck(values?.neftData) && (
							<Flex justifyContent="center" alignItems="center">
								<Text
									as="p"
									color="#ff4d4f"
									fontSize="12px"
									maxWidth="250px"
									textAlign="center"
								>
									* Duplicate NEFT Reference numbers, please check it
								</Text>
							</Flex>
						)}
						{UPIRefCheck(values?.upiData) && (
							<Flex justifyContent="center" alignItems="center">
								<Text
									as="p"
									color="#ff4d4f"
									fontSize="12px"
									maxWidth="250px"
									textAlign="center"
								>
									* Duplicate UPI Reference numbers, please check it
								</Text>
							</Flex>
						)}

						{!verifiedBy?.cashier && (
							<Row className="mt-15" justify="space-around" align="middle">
								<Col span={12} className="left">
									{!verifiedBy?.segregator && (
										<ClearBtn
											type="button"
											onClick={() => setShowClearConfirmation(true)}
											style={{
												width: '100%',
											}}
										>
											Clear
										</ClearBtn>
									)}
								</Col>
								<Col span={12} className="right">
									{NEFTRefCheck(values?.neftData) &&
									UPIRefCheck(values?.upiData) ? (
										<ConfirmBtn
											disabled={
												!isValid ||
												getBalanceAmount(values) !== 0 ||
												!isEmpty(errors) ||
												!dirty ||
												UPIRefCheck(values?.upiData) ||
												NEFTRefCheck(values?.neftData)
											}
											onClick={() => setShowDuplicateError(true)}
											style={style}
										>
											{isEditMode ? 'Update' : 'Save'}
										</ConfirmBtn>
									) : (
										<SaveBtn
											style={style}
											disabled={
												(getBalanceAmount(values) !== 0 &&
													getSplitedTotal(values) > 0) ||
												getBalanceAmount(values) !== 0 ||
												!isEmpty(errors) ||
												!dirty ||
												UPIRefCheck(values?.upiData) ||
												NEFTRefCheck(values?.neftData)
											}
										>
											{isEditMode ? 'Update' : 'Save'}
										</SaveBtn>
									)}
								</Col>
							</Row>
						)}
						{process.env.NODE_ENV === 'development' && <Debug />}
						<DynamicQRCode
							visible={showDynamicQRCode}
							handleCancel={handleUPIQRCodeClose}
							totalOutstanding={Number(totalOutstanding) - getBalanceAmount(values)}
							upiData={me?.upi || selectedSalesMan?.upi}
							storeData={storeInvoices?.[0]}
							UPIRefFieldIndex={UPIRefFieldIndex}
							dynamicUPIData={dynamicUPIData}
							setDynamicUPIData={setDynamicUPIData}
							manualModeEditData={manualModeEditData}
							formRef={formRef}
							handleDeleteManualUPI={handleDeleteManualUPI}
							handleQRCodeSubmit={handleQRCodeSubmit}
							storeInvoices={storeInvoices}
						/>
					</Form>
				)}
			</Formik>

			<DuplicateReferenceConfirmation
				visible={showDuplicateError}
				handleOk={handleOk}
				handleCancel={handleCancel}
			/>
			<ConfirmBeforeUpdate
				visible={showUpdateConfirmation}
				handleOk={handleUpdateOk}
				handleCancel={handleUpdateCancel}
			/>

			<ClearConfirmation
				visible={showClearConfirmation}
				onClose={() => setShowClearConfirmation(false)}
				onClear={clearBottomInvoices}
				infoText="Are you sure want to clear the splited invoices details"
			/>

			{showUpiPopup && (
				<AutoCompleteUpi
					setShowUpiPopup={setShowUpiPopup}
					showUpiPopup={showUpiPopup}
					storeData={storeInvoices?.[0]}
					formRef={formRef}
					UPIRefFieldIndex={UPIRefFieldIndex}
				/>
			)}
		</>
	);
}

InvoiceFormAmortization.propTypes = {
	storeInvoices: PropTypes.arrayOf(
		PropTypes.shape({
			status: PropTypes.string,
			reason: PropTypes.number,
			remarks: PropTypes.string,
			paid: PropTypes.number,
			billtype: PropTypes.string,
			payment: PropTypes.array,
			amount: PropTypes.number,
			initial_outstanding_amount: PropTypes.string,
			current_outstanding_amount: PropTypes.string,
			verified_by_segregator_id: PropTypes.number,
			verified_by_cashier_id: PropTypes.number,
			delegated_salesman_name: PropTypes.string,
			id: PropTypes.number,
			store_id: PropTypes.number,
			store_name: PropTypes.string,
			invoice_verification_status: PropTypes.string,
		})
	).isRequired,
	totalOutstanding: PropTypes.any,
	isEditMode: PropTypes.bool,
	previousUPIPayments: PropTypes.array,
	deliveryDate: PropTypes.object,
};
